import { WindowService } from 'pf-frontend-common/src/service/window/service';

import { BrowserSupport } from 'common/module/browser/support';

const service = new BrowserSupport(new Image(), WindowService());

export const BrowserSupportService = () => service;
